<template>
  <div class="ly-pagenation">
    <el-button type="paging" :disabled="doublePrevDisabled" @click="doublePrev"
      ><i class="icon-CaretDoubleLeft"
    /></el-button>
    <el-pagination
      layout="prev,pager,next"
      :current-page.sync="pageInfo.curPage"
      :page-count="pageInfo.totalBlock"
      :total="pageInfo.totalListSize"
      :page-size="pageInfo.pageListSize"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      v-on="$listeners"
      v-bind="$attrs"
    >
    </el-pagination>
    <el-button type="paging" :disabled="doubleNextDisabled" @click="dobleNext"
      ><i class="icon-CaretDoubleRight"
    /></el-button>
  </div>
</template>

<script>
export default {
  props: {
    pageInfo:{
      type: Object,
      default:()=>{}
    }
  },
  data() {
    return {};
  },
  computed: {
    doublePrevDisabled() {
      if (this.pageInfo.curPage) {
        return this.pageInfo.curPage === 1 ? true : false;
      }
      return false;
    },
    doubleNextDisabled() {
      if(this.pageInfo.totalBlock == 0 || this.pageInfo.curPage == this.pageInfo.totalBlock){
        return true;
      }else{
        return false;
      }
    },
  },
  methods: {
    handleSizeChange(val){
      this.pageInfo.pageListSize = val;
    },
    handleCurrentChange(val) {
      // console.log(`current page: ${val}`);
      this.pageInfo.curPage = val;
      this.$emit('movePage', val)
      this.$emit('movePageMulti', this.pageInfo)
    },
    dobleNext() {
      this.pageInfo.curPage = this.pageInfo.totalBlock;
      this.handleCurrentChange(this.pageInfo.curPage)
    },
    doublePrev() {
      this.pageInfo.curPage = 1;
      this.handleCurrentChange(this.pageInfo.curPage)
    },
  },
};
</script>
<style lang="scss" scoped>
.ly-pagenation {
  text-align: center;
  font-size: 0;
  ::v-deep {
    .el-pagination {
      display: inline-block;
      vertical-align: top;
      button {
        height: 38px;
        font-size: $--font-size-base;
      }
      li {
        height: 38px;
        line-height: 38px;
        font-size: $--font-size-base;
        &.active {
          font-weight: $--font-weight-bold;
        }
      }
    }
    .el-button--paging {
      display: inline-block;
      vertical-align: top;
      font-size: $--font-size-base;
    }
  }
}
</style>
